<template>
  <TsMedia
    :append-class="
      twMerge(
        'rounded-lg text-left relative group/highlight-card',
        props.variant === 'navy-blue' &&
          'bg-[linear-gradient(115deg,_#2EB5CD_9.07%,_#0398B3_92.33%)]',
        props.variant === 'yellow' &&
          'bg-[linear-gradient(109.25deg,#FBD504_7.25%,#E2C10A_105.69%)]',
        props.variant === 'blue' &&
          'bg-[linear-gradient(256.49deg,#012442_15.42%,#004070_99.43%)]'
      )
    "
  >
    <TsButton
      :data-testid="`${dataTestid}_button_${id}`"
      append-class="opacity-0 group-hover/highlight-card:opacity-100 transition-all duration-300 bg-[#1094AC] border-[#52C9DF] absolute top-2 right-2 py-2 px-2 text-xs leading-[10px]"
      size="xs" rounded>
      <TsCursorIcon width="16" />
      <span>
        CLICK & VIEW
      </span>
    </TsButton>
    <TsMediaStart append-class="pr-0 p-4 flex-1 mr-0">
      <TsImage v-if="props.brandLogo" :src="props.brandLogo" :alt="props.brand_logo_alt" :data-testid="`${dataTestid}_logo_${id}`" width="68" height="16" class="mb-2" loading="lazy"/>
      <TsTypography :data-testid="`${dataTestid}_title_${id}`" variant="h2" :append-class="twMerge(
        'mb-0 text-idle-white',
        props.variant === 'yellow' && 'text-natural-dark-grey',
      )">
        {{ props.title }}
      </TsTypography>
      <TsTypography
        :data-testid="`${dataTestid}_type_${id}`"
        variant="xs"
        :append-class="
          twMerge(
            'mb-2 text-idle-white',
            props.variant === 'yellow' && 'text-natural-dark-grey'
          )
        "
      >
        {{ props.type }}
      </TsTypography>
      <TsButton size="xs">Know More</TsButton>
    </TsMediaStart>
    <TsMediaContent append-class="flex-1 basis-0">
      <TsImage :data-testid="`${dataTestid}_image_${id}`" v-if="props.image" :src="props.image" :alt="props.image_alt" width="205" height="205" loading="lazy"/>
    </TsMediaContent>
  </TsMedia>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);



const TsCursorIcon = defineAsyncComponent(
    () => import('~/components/atoms/icons/TsCursorIcon.vue')
);
type ColorVariants = "blue" | "yellow" | "navy-blue";

export type HighlightCardProps = {
  id: string;
  variant: ColorVariants;
  brand_logo: string;
  brand_logo_alt: string;
  title: string;
  type: string;
  image: string;
  image_alt: string;
};

type Props = HighlightCardProps & {
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {
  id: "1",
  brand_logo: "/images/logos/makita.png",
  brand_logo_alt: "brand logo for highlighted product",
  title: "Avail benefits up to €199.00",
  variant: "navy-blue",
  type: "Cordless Drill",
  image: "/images/makita-tool.png",
  image_alt: "highlighted product with deal",
});
</script>
